export default "assets/images/icons/arrow-light-f5f29eb6.svg";